// removed by extract-text-webpack-plugin
module.exports = {"blackFriday":"qempo_BlackFridayBanner_blackFriday-3Dg1GqP","content":"qempo_BlackFridayBanner_content-38HPt6X","text":"qempo_BlackFridayBanner_text-2KfL7AF","timeWrap":"qempo_BlackFridayBanner_timeWrap-IsIhctr","unitWrap":"qempo_BlackFridayBanner_unitWrap-2Nrcdor","fromMobile":"qempo_BlackFridayBanner_fromMobile-2TBFYI8","number":"qempo_BlackFridayBanner_number-3t-k2v8"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/home/components/BlackFridayBanner/BlackFridayBanner.scss
// module id = 1450
// module chunks = 0